/**
 * Depth tags a user message may start with (read by shanks
 * connecthandlers/depth.go): [quick] answers fast from a few reads,
 * [deeper] works the previous answer properly. The tag stays in the stored
 * message; the thread shows it as a chip.
 */ export const QUICK_TAG = '[quick]';
export const DEEPER_TAG = '[deeper]';
export const GO_DEEPER_MESSAGE = `${DEEPER_TAG} Go deeper on this.`;
/** Replies shorter than this get a "Go deeper" offer even without [quick]. */ export const SHORT_REPLY_CHARS = 1200;
const QUICK_STORAGE_KEY = 'specra.chat.quickMode';
/** The depth tag a message starts with and the text after it. */ export function parseDepth(text) {
    // The composer stores a typed "[quick]" markdown-escaped as "\[quick\]".
    const trimmed = text.trimStart().replace(/^\\\[([a-zA-Z]+)\\\]/, '[$1]');
    const lower = trimmed.toLowerCase();
    for (const [tag, depth] of [
        [
            QUICK_TAG,
            'quick'
        ],
        [
            DEEPER_TAG,
            'deeper'
        ]
    ]){
        if (lower.startsWith(tag)) return {
            depth,
            rest: trimmed.slice(tag.length).trim()
        };
    }
    return {
        depth: null,
        rest: text
    };
}
/** The text a depth-tagged user message shows after its chip. */ export function depthDisplayText(text) {
    const parsed = parseDepth(text);
    if (parsed.depth === 'deeper' && parsed.rest === 'Go deeper on this.') {
        return {
            depth: 'deeper',
            rest: ''
        };
    }
    return parsed;
}
/** Prefixes [quick] when quick mode is on (never twice, never on an empty prompt). */ export function applyQuickPrefix(prompt, quick) {
    if (!quick || !prompt.trim() || parseDepth(prompt).depth) return prompt;
    return `${QUICK_TAG} ${prompt}`;
}
/** Offer "Go deeper" after a quick answer or a short reply (not right after going deeper). */ export function shouldOfferGoDeeper(previousUserText, replyText) {
    if (!replyText.trim()) return false;
    const depth = parseDepth(previousUserText).depth;
    if (depth === 'deeper') return false;
    return depth === 'quick' || replyText.length < SHORT_REPLY_CHARS;
}
export function readQuickMode() {
    try {
        return window.localStorage.getItem(QUICK_STORAGE_KEY) === '1';
    } catch  {
        return false;
    }
}
export function writeQuickMode(on) {
    try {
        window.localStorage.setItem(QUICK_STORAGE_KEY, on ? '1' : '0');
    } catch  {
    // storage unavailable (private window); the toggle still works this session
    }
}
